<template>
  <!-- 高级参照 -->
  <!--   :background-color="disabled ? backgroundColor : '#f5f5f5'" -->
  <div style="width: 100%" class="promptBox">
    <template v-if="view">
      {{ inputShowName }}
    </template>
    <template v-else>
      <v-autocomplete
        :value="promptValue"
        :readonly="disabled"
        :disabled="disabledTwo"
        :search-input.sync="search"
        :items="prompt_arr"
        :append-icon="disabled ? '' : 'arrow_drop_down'"
        :no-data-text="noDataText"
        :item-value="value_field"
        :item-text="view_fields"
        :label="label"
        required
        :filter="filterArr"
        :background-color="
          backgroundColor ? backgroundColor : disabled ? '#ffffff' : '#f5f5f5'
        "
        :clearable="clearable"
        :multiple="multiple"
        @change="promptChange"
        :error-messages="errMsg"
        :placeholder="
          placeholder
            ? removestar(placeholder)
            : disabled
            ? ' '
            : removestar(label)
        "
        :rules="myRules"
      >
        <template v-slot:no-data>
          <mrc_ess_noContent
            height="50"
            type="2"
            svgFontSize="50"
            :no_data_text="$t('label_blank')"
          />
        </template>
        <!-- :placeholder="disabled ? ' ' : label" -->
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            v-if="multiple"
            :input-value="data.selected"
            :close="!disabled"
            @click="data.select"
            @click:close="remove(data.item)"
          >
            <template v-if="!hideItem">
              {{ INT(data.item[view_fields]) }}
            </template>
            <slot name="selection" :data="data"></slot>
          </v-chip>
          <div v-else class="d-flex align-center">
            <v-chip
              v-bind="data.attrs"
              v-if="chips"
              :input-value="data.selected"
              :close="!disabled"
              @click="data.select"
              @click:close="remove(data.item)"
            >
              <template v-if="!hideItem">
                {{ INT(data.item[view_fields]) }}
              </template>
              <slot name="selection" :data="data"></slot>
            </v-chip>

            <div v-else style="color: rgba(0, 0, 0, 0.87)">
              <template v-if="!hideItem">
                {{ INT(data.item[view_fields]) }}
              </template>
              <slot name="selection" :data="data"></slot>
            </div>
          </div>
        </template>
        <!-- 下拉数据 -->
        <template v-slot:item="data">
          <v-list-item-content
            class="pa-0"
            style="height: 48px; border-bottom: 1px solid rgb(224, 224, 224)"
            v-if="multiple && data.item.allcheck"
          >
            <div @click.stop="allcheck" style="height: 48px" class="px-4">
              <v-checkbox
                class="pt-4"
                :label="$t('label_select_all')"
                :on-icon="
                  statusCheck == 'indeterminate'
                    ? '$checkboxIndeterminate'
                    : '$checkboxOn'
                "
                readonly
                v-model="statusCheck"
              >
              </v-checkbox>
            </div>
          </v-list-item-content>
          <div v-else style="height: 48px" class="d-flex align-center pl-4">
            <v-checkbox
              v-if="multiple"
              class="pt-6"
              v-model="data.attrs.inputValue"
            >
            </v-checkbox>
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content
                v-text="data.item"
                style="height: 48px"
              ></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content style="height: 48px" v-if="!hideItem">
                {{ INT(data.item[view_fields]) }}
              </v-list-item-content>
              <slot name="item" :data="data"></slot>
            </template>
          </div>
        </template>
      </v-autocomplete>
    </template>
  </div>
</template>

<script>
/**
 * info 公用高级参照组件 可传单个prompt_name 或者 对象形式 多个参数
 * @params label 标签名
 * @params disabled 是否禁用
 * @params obj 请求的条件 prompt_name 等   优化 obj 可以只传一个字符串 不用写prompt_name属性了
 * @params noDataText 没有下拉显示的文字
 * @params select_arr 下拉的数据
 * @params multiple 多选
 * @params rules 为空时显示的字，默认提示为 '必填提示'
 * @params prompt_name 只有一个参照名字的参数时就可能不用传obj直接传名字
 * @params prompt 传的value值
 * @params chips 选中的纸片样式
 * @params clearable 清空
 * @params errMsg 手动输入错误消息   有这个属性那 rules就必须传false
 * @params value_field 隐藏值存在的属性
 * @params view_fields 显示值存在的属性
 * @params str 在多选属性的情况下，能传字符串进来，输入也是选择对应的字符串
 * @event  getSelectItem 获取选中项的一列数据
 * @event  getData  select 改变的事件
 * @event  getPromptData 返回下拉数组
 * 使用 <mrc_ess_mrc_ess_prompt></mrc_ess_prompt>
 */
import { getBusinessList } from "@/service/api/prompt";
export default {
  components: {},
  props: {
    hideItem: {
      type: Boolean,
      default: false,
    },
    colorView: {
      //颜色显示
      type: Boolean,
      default: false,
    },
    view: {
      type: Boolean,
      default: false,
    },
    filled: {},
    backgroundColor: {
      type: String,
    },
    value_field: {
      type: String,
      default: "value_field",
    },
    view_fields: {
      type: String,
      default: "view_fields",
    },
    placeholder: {
      type: String,
    },
    errMsg: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    prompt_name: {
      type: String,
    },
    label: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    disabledTwo: {
      type: Boolean,
      default: false,
    },
    obj: {
      type: [Object, String],
    },
    noDataText: {
      type: String,
    },
    select_arr: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
    },
    rules: {
      type: [String, Boolean],
    },
    prompt: {
      type: [Array, String, Number, null],
    },
    str: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      search: null,
      prompt_arr: [],
      requestData: {},
      skLoading: true,
      showName: "",
      nationalPromptArr: [],
    };
  },
  model: {
    prop: "prompt",
    event: "getData",
  },
  async created() {
    this.nationalPromptArr = this.select_arr;
    this.changeLang();
    if (this.select_arr.length <= 0) {
      if (typeof this.obj == "string") {
        const prompt = await getBusinessList({
          prompt_name: this.obj,
          value: Array.isArray(this.prompt)
            ? this.prompt.join(",")
            : this.prompt,
        });
        if (prompt.code == 200) {
          this.nationalPromptArr = prompt.data;
          this.changeLang();
          this.$emit("getPromptData", this.prompt_arr);
        }
      } else {
        this.requestData = this.obj ? this.obj : {};
        if (Object.keys(this.requestData).length > 0) {
          const prompt = await getBusinessList({
            ...this.requestData,
            value: Array.isArray(this.prompt)
              ? this.prompt.join(",")
              : this.prompt,
          });
          if (prompt.code == 200) {
            this.nationalPromptArr = prompt.data;
            this.changeLang();
            this.$emit("getPromptData", this.prompt_arr);
          }
        }
      }
    }
    if (this.prompt_name) {
      const prompt = await getBusinessList({
        prompt_name: this.prompt_name,
        value: Array.isArray(this.prompt) ? this.prompt.join(",") : this.prompt,
      });
      if (prompt.code == 200) {
        this.nationalPromptArr = prompt.data;
        this.changeLang();
        this.$emit("getPromptData", this.prompt_arr);
      }
    }
    this.setShowName();
    // this.skLoading = false
  },
  async mounted() {},
  methods: {
    removestar(v) {
      return String(v).replace("*", "");
    },
    allcheck(val) {
      let arr = this.$clone(this.prompt_arr);
      // console.log(this.statusCheck, !this.statusCheck);
      if (!this.statusCheck || this.statusCheck == "indeterminate") {
        let uuids = [];
        arr.splice(0, 1);
        arr.forEach((item) => {
          uuids.push(item[this.value_field]);
        });
        this.$nextTick(() => {
          if (this.str) {
            this.$emit("getData", uuids.join());
            this.$emit("getSelectItem", arr);
          } else {
            this.$emit("getData", uuids);
            this.$emit("getSelectItem", arr);
          }
        });
      } else {
        this.$nextTick(() => {
          if (this.str) {
            this.$emit("getData", "");
            this.$emit("getSelectItem", "");
          } else {
            this.$emit("getData", []);
            this.$emit("getSelectItem", []);
          }
        });
      }
    },
    remove(item) {
      let selectItem = [];
      if (this.multiple) {
        let arr = [];
        if (this.str) {
          arr = JSON.parse(JSON.stringify(this.prompt))
            .split(",")
            .filter((it) => {
              return it != item[this.value_field];
            });
          this.$emit("getData", arr.join(","));
        } else {
          arr = JSON.parse(JSON.stringify(this.prompt)).filter((it) => {
            return it != item[this.value_field];
          });
          this.$emit("getData", arr);
        }

        selectItem = JSON.parse(JSON.stringify(this.prompt_arr)).filter(
          (it) => arr.indexOf(it[this.value_field]) > -1
        );
        this.$emit("getSelectItem", selectItem);
      } else {
        this.$emit("getData", "");
        this.$emit("getSelectItem", {});
      }
    },
    filterArr(item, query) {
      // console.log(item, query)
      if (query) {
        if (!this.INT(item[this.view_fields])) return false;
        const a = this.filterList
          .filter((it) => {
            let key1 = it[this.view_fields];
            let key2 = query;
            if (typeof it[this.view_fields] != "number") {
              key1 = it[this.view_fields].toLowerCase();
              key2 = query.toLowerCase();
            }
            // return key1.match(key2)
            return String(key1).includes(String(key2));
          })
          .map((its) => its[this.value_field]);
        return a.includes(item[this.value_field]);
      }
    },
    formatList(arr) {
      const key = this.view_fields;
      const value = this.value_field;
      let list = [];
      arr.forEach((item) => {
        if (Array.isArray(item[key])) {
          item[key].forEach((it) => {
            for (let lang in it) {
              if (lang != "uuid") {
                list.push({
                  [value]: item[value],
                  [key]: it[lang],
                  uuid: it.uuid,
                });
              }
            }
          });
          // console.log(list)
        } else {
          list.push(item);
        }
      });
      // console.log(list)
      return list;
    },
    changeLang() {
      this.prompt_arr = this.$clone(this.nationalPromptArr).map((item) => {
        item[this.view_fields] = this.INT(item[this.view_fields]);
        return item;
      });
      if (this.multiple) {
        this.prompt_arr = [{ allcheck: "allcheck" }, ...this.prompt_arr];
      }
    },
    promptChange(val) {
      this.setShowName();
      if (this.str && this.multiple) {
        this.$emit("getData", val.join(","));
      } else {
        this.$emit("getData", val ? val : this.multiple ? [] : "");
      }

      const item = this.prompt_arr.filter((item) => {
        if (this.multiple) {
          return val.indexOf(item[this.value_field]) > -1;
        } else {
          return val == item[this.value_field];
        }
      });
      if (this.multiple) {
        this.$emit("getSelectItem", item);
      } else {
        this.$emit("getSelectItem", item[0] || {});
      }
    },
    setShowName() {
      if (Object.prototype.toString.call(this.prompt).indexOf("Array") > -1) {
        // let index = []
        // console.log(this.prompt,this.prompt_arr,this.value_field,this.view_fields);
        let indexArr = this.prompt.reduce((totle, item) => {
          let index = this.prompt_arr.findIndex((it) => {
            return it[this.value_field] == item;
          });
          totle.push(index);
          return totle;
        }, []);
        let html = "";
        indexArr.forEach((item, index) => {
          if (item > -1) {
            // this.INT(this.prompt_arr[item][this.view_fields])
            html +=
              this.prompt_arr[item][this.view_fields] +
              (index == indexArr.length - 1 ? "" : "，");
          }
        });
        this.showName = html;
        // 00000000-0000-0000-0000-000000000000
      } else {
        const index = this.prompt_arr.findIndex((item) => {
          return item[this.value_field] == this.prompt;
        });

        if (index != -1) {
          // this.INT(this.prompt_arr[index][this.view_fields])
          this.showName = this.prompt_arr[index][this.view_fields];
        } else {
          this.showName = "";
        }
      }
    },
  },
  computed: {
    statusCheck() {
      let uuidLength = this.promptValue.length;
      let length = this.prompt_arr.length - 1;
      if (uuidLength == length) return true;
      else if (uuidLength > 0) return "indeterminate";
      else return false;
    },
    promptValue() {
      let prompt;
      if (this.multiple) {
        prompt = [];
        if (this.str) {
          this.prompt ? (prompt = this.$clone(this.prompt).split(",")) : [];
        } else {
          this.prompt ? (prompt = this.$clone(this.prompt)) : (prompt = []);
        }
      } else {
        this.prompt ? (prompt = this.$clone(this.prompt)) : (prompt = "");
      }
      return prompt;
    },
    filterList() {
      return this.formatList(this.nationalPromptArr);
    },
    myRules() {
      if (this.rules == false) {
        return [];
      } else {
        return [(v) => !!v || this.rules];
      }
    },
    inputShowName() {
      let inputShowName = "";
      if (this.showName && String(this.showName).indexOf("，") > -1) {
        inputShowName = this.showName
          .split("，")
          .map((item) => this.INT(item))
          .join("，");
      } else {
        inputShowName = this.showName;
      }
      return inputShowName;
    },
  },
  watch: {
    "$store.state.lang"(val) {
      this.changeLang();
    },
    obj: {
      async handler(val, old) {
        // console.log(JSON.stringify(old) == JSON.stringify(val))
        if (JSON.stringify(old) == JSON.stringify(val)) return;
        this.requestData = val;
        if (typeof val == "string") {
          const prompt = await getBusinessList({ prompt_name: val });
          if (prompt.code == 200) {
            this.nationalPromptArr = prompt.data;
            this.changeLang();
            this.$emit("getPromptData", this.prompt_arr);
          }
        } else {
          // 这里有个return 阻断执行，，报错看看这个
          // for (var i in this.requestData) {
          //   if (i != 'prompt_name') {
          //     if (!this.requestData[i]) return
          //   }
          // }
          if (!this.requestData.prompt_name) return;
          const prompt = await getBusinessList({ ...this.requestData });
          if (prompt.code == 200) {
            this.nationalPromptArr = prompt.data;
            this.changeLang();
            this.skLoading = false;
            this.$emit("getPromptData", this.prompt_arr);
          }
        }
        if (this.prompt) {
          this.setShowName();
        }
      },
      deep: true,
    },
    select_arr: {
      handler(val) {
        this.nationalPromptArr = val;
        this.changeLang();
        this.setShowName();
      },
      deep: true,
    },
    // prompt_arr: {
    //   handler(val) {
    //   },
    //   deep:true
    // },
    prompt: {
      handler(val) {
        if (val == "") this.showName = "";
        this.prompt_arr.length > 0 && this.setShowName();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.selectShow {
  width: 0px;
}
.inputShow {
  width: 0px;
}
/* .promptBox /deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
} */
.promptBox /deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.promptBox /deep/ .v-input__slot {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.promptBox /deep/.v-input .v-label {
  top: 2px !important;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
  max-height: 56px !important;
}
.v-input--selection-controls {
  margin: 0;
  padding: 0;
}
/deep/ .v-select__slot {
  min-height: 40px;
}
/deep/ .v-select__selections {
  min-height: 40px;
  padding-left: 8px;
}
/deep/ .v-list-item {
  min-height: 40px !important;
  padding: 0;
}
/deep/ .v-list-item__content {
  min-height: 40px !important;
}
.overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
/deep/ .v-input__append-inner {
  margin-top: 8px;
  margin-right: 8px;
}
.v-application--is-ltr .v-text-field .v-input__prepend-inner {
  padding: 0 !important;
}
</style>
